import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import eventFormatter from '#component/device/event-formatter';
import PreloaderComponent from '#component/preloader';
import { EmptyLogs } from '#component/project/project-log/empty-log';
import EventDescription from '#component/project/project-log/event-description';
import LogCard from '#component/general/log-card';
import { StyledLogsList } from './styles';

/**
 * Renders cards with log info.
 * @returns {React.FC}
 */

const MobileView = props => {
  const { account, loading, error, logs } = props;

  if (!logs.length && loading) {
    return <PreloaderComponent />;
  }

  if (error) {
    return <EmptyLogs />;
  }

  return logs.length > 0 ? (
    <StyledLogsList loading={loading}>
      {logs.map((log, i) => (
        <LogCard
          key={i}
          log={log}
          account={account}
          icon={<DashboardIcon />}
          EventDescriptionComponent={EventDescription}
          eventFormatter={eventFormatter}
        />
      ))}
    </StyledLogsList>
  ) : (
    <EmptyLogs />
  );
};

export default MobileView;
